import React, { memo } from 'react';
import cls from '../MassActionsPanel.module.css';
import { useGroupingBlock } from './useGroupingBlock';
import { useTranslation } from 'react-i18next';

export const GroupingBlock = memo(
    ({
        showGroupButton,
        disabledGroupButton,
        showUngroupButton,
        disabledUngroupButton,
        setShowGroupButton,
        setShowUngroupButton,
        setDisabledUngroupButton,
        setDisabledGroupButton,
    }) => {
        const { grouping, unGrouping } = useGroupingBlock(
            setShowGroupButton,
            setShowUngroupButton,
            setDisabledUngroupButton,
            setDisabledGroupButton
        );
        const { t } = useTranslation();

        return (
            <>
                {showGroupButton && (
                    <button
                        disabled={disabledGroupButton}
                        className={cls.button}
                        onClick={(e) => grouping(e)}
                    >
                        <span>
                            {t('GroupingBlock.GroupBtn.text')}
                            <span className="into-chapter">
                                {' '}
                                {t('GroupingBlock.GroupBtn.intoChapter.text')}
                            </span>
                        </span>
                    </button>
                )}
                {showUngroupButton && (
                    <button
                        disabled={disabledUngroupButton}
                        onClick={(e) => unGrouping(e)}
                        className={cls.button}
                    >
                        <span>{t('GroupingBlock.UnGroupBtn.text')}</span>
                    </button>
                )}
            </>
        );
    }
);
